/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { Modal , Alert} from 'react-bootstrap';
import styled from 'styled-components';
import "../formas/styles.scss"

const ModalCoberturasMarineInland = ({
  baseClassName = 'w-100 text-centrado',
  className = '',
  data = [],
  moneda='mxn',
  label = 'Ver coberturas',
}) => {
  const [modalShow, setModalShow] = useState(false); 
  return (
    <React.Fragment>
      <div
        className={`${baseClassName} ${className}`}        
      >
        <a
          className="font-futura-medium cpointer ver-coberturas-popup"          
          onClick={() => {
            setModalShow(true);
          }}
        >
          {label}
        </a>
      </div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>          
          <div>
            <div className='title-cob-popup py-3 px-2'>Cobertura Básica</div>
            <div className='title-cob-popup py-3 px-2 my-3'>Coberturas Adicionales</div>
            <List>
              {data?.map((item) => (
                <li key={item?.id} className="mt-3 d-flex ">                                                             
                      <div className='col-8 my-0 py-0  font-popup font-source-sans-regular'>{item?.label}</div>
                      <div className='col-4 my-0 py-0 text-right font-popup font-source-sans-regular'>{item?.totAsegurado}</div>                                                   
                </li>
              ))}
              <br></br>
              {data.length == 0 &&
                <Alert variant={"info"}>No se han seleccionado coberturas adicionales.</Alert>
              }
            </List>
          </div>          
        </Modal.Body>        
      </Modal>
    </React.Fragment>
  );
};

export default ModalCoberturasMarineInland;

const List = styled.ul`
  font-size: 18px;
  list-style: none;
  font-family: 'Source Sans Pro';
  font-weight: 500 !important;
  padding-left: 0px;
  & > li {    
    @media (min-width: 550px) {
      width: 480px !important;
    }
    @media (min-width: 650px) {
      width: 550px !important;
    }
    @media (min-width: 750px) {
      width: 650px !important;
    }
  }
`;
